let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5i5pX")).then(() => parcelRequire('ltRMD'));